import React, { useState, useEffect, useCallback } from "react";
import { getActivities } from "../../api/activity";
import { GetActivitiesResponse, ActivityDTO } from "../../types/requestsOutputs";
import { ActivityPanel } from "../../components/cards/Activity";
import EditActivityModal from "./EditActivityModal";

const ActiveActivities: React.FC = () => {
    const [activities, setActivities] = useState<GetActivitiesResponse>({
        products: [],
    });
    const [editingActivity, setEditingActivity] = useState<ActivityDTO | null>(null);
    const [isEditModalOpen, setIsEditModalOpen] = useState(false);

    const getActivitiesAPI = useCallback(async () => {
        const token = localStorage.getItem("token");
        if (!token) {
            console.error("No token found");
            return;
        }
        const data = await getActivities({ token });
        if (data) {
            console.log("Activities fetched successfully", data);
            setActivities(data);
        } else {
            console.error("Failed to fetch activities");
        }
    }, []); // No dependencies needed unless `token` comes from props/context

    useEffect(() => {
        getActivitiesAPI();
    }, [getActivitiesAPI]);

    const handleEdit = (activity: ActivityDTO) => {
        setEditingActivity(activity);
        setIsEditModalOpen(true);
    };

    const handleEditClose = () => {
        setIsEditModalOpen(false);
        setEditingActivity(null);
    };

    const handleEditSuccess = () => {
        handleEditClose();
        getActivitiesAPI();
    };

    return (
        <div>
            <ActivityPanel
                activities={activities}
                locale="iduniquefr"
                refetch={() => getActivitiesAPI()}
                onEdit={handleEdit}
            />
            {editingActivity && (
                <EditActivityModal
                    isOpen={isEditModalOpen}
                    onClose={handleEditClose}
                    activity={editingActivity}
                    onSuccess={handleEditSuccess}
                />
            )}
        </div>
    );
};

export default ActiveActivities;
